const DOCTOR_TITLE = /^(?:(?:prof(?:essor)?|consultant)\.?\s+)?dr\.?\s+/i;

export function formatDoctorName(name, salutation = "Dr.", fallback = "Doctor") {
  const cleanName = String(name || "").trim().replace(/\s+/g, " ");
  if (!cleanName) return fallback;
  if (DOCTOR_TITLE.test(cleanName)) return cleanName;
  const cleanSalutation = String(salutation || "Dr.").trim().replace(/\s+/g, " ");
  return `${cleanSalutation || "Dr."} ${cleanName}`;
}
